var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63604 0.362793C1.43106 0.362793 0.454224 1.33963 0.454224 2.54461V12.7264C0.454224 13.9314 1.43106 14.9082 2.63604 14.9082H19.3633C20.5683 14.9082 21.5451 13.9314 21.5451 12.7264V2.54461C21.5451 1.33963 20.5683 0.362793 19.3633 0.362793H2.63604ZM1.90877 2.54461C1.90877 2.14295 2.23438 1.81734 2.63604 1.81734H15.9849C15.3817 2.21278 14.9993 2.89257 14.9993 3.64226V11.6298C14.9993 12.3788 15.3811 13.0581 15.9834 13.4537H2.63604C2.23438 13.4537 1.90877 13.1281 1.90877 12.7264V2.54461ZM19.1631 2.3196C19.6277 2.18686 20.0902 2.5357 20.0902 3.01889V12.2531C20.0902 12.7363 19.6277 13.0852 19.1631 12.9524L16.9813 12.329C16.6691 12.2398 16.4538 11.9545 16.4538 11.6298V3.64226C16.4538 3.31755 16.6691 3.03218 16.9813 2.94297L19.1631 2.3196Z",
    fill: "#00A7B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.bb500332ffe844fa00dd71c7b0876f74.svg";
export { ForwardRef as ReactComponent };